(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASE = 0.1;
    var SPEED = 0.75;
    var grids = document.querySelectorAll('.image-gallery-grid__grid--horizontal-scroll');

    grids.forEach(function (grid) {
      var target = grid.scrollLeft;
      var running = false;
      var snapTimer = null;

      function tick() {
        var diff = target - grid.scrollLeft;

        if (Math.abs(diff) < 1) {
          grid.scrollLeft = target;
          running = false;
          restoreSnap();
          return;
        }

        grid.scrollLeft += diff * EASE;
        requestAnimationFrame(tick);
      }

      function disableSnap() {
        clearTimeout(snapTimer);
        grid.style.scrollSnapType = 'none';
      }

      function restoreSnap() {
        snapTimer = setTimeout(function () {
          grid.style.scrollSnapType = '';
        }, 150);
      }

      grid.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;

        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var atStart = target <= 0 && e.deltaY < 0;
        var atEnd = target >= maxScroll && e.deltaY > 0;

        if (atStart || atEnd) return;

        e.preventDefault();
        disableSnap();
        target = Math.max(0, Math.min(maxScroll, target + e.deltaY * SPEED));

        if (!running) {
          running = true;
          requestAnimationFrame(tick);
        }
      }, { passive: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
